var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreysun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.75V2.25M9.5 15.75V17.25M17.75 9H16.25M2.75 9H1.25M15.3336 3.16637L14.273 4.22703M4.72703 13.773L3.66637 14.8336M15.3336 14.8336L14.273 13.773M4.72703 4.22703L3.66637 3.16637M14 9C14 11.4853 11.9853 13.5 9.5 13.5C7.01472 13.5 5 11.4853 5 9C5 6.51472 7.01472 4.5 9.5 4.5C11.9853 4.5 14 6.51472 14 9Z",
    stroke: "#919DA9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreysun);
export default __webpack_public_path__ + "static/media/greysun.90428a0415c66b6b07e63f9013ab0157.svg";
export { ForwardRef as ReactComponent };